import accountProvider from "../api/account"
import userProvider from "../api/user"
import { getCurrentEnvironment } from "../environmentHelper"
import storage from "../localStorage"

const LOCAL_STORAGE_USER_KEY_EU = "userEU"
const LOCAL_STORAGE_USER_KEY_US = "userUS"
const LOCAL_STORAGE_USER_KEY_UK = "userUK"


export const getUserToken = () => {
  const currentEnv = getCurrentEnvironment()
  const key = currentEnv === "uk" ? LOCAL_STORAGE_USER_KEY_UK : currentEnv === "eu" ? LOCAL_STORAGE_USER_KEY_EU : LOCAL_STORAGE_USER_KEY_US
  const data = storage.getItem(key)
  if (!data) {
    return null
  }
  return data
}

export const setUserToken = (token) => {
  
  const currentEnv = getCurrentEnvironment()
  const key = currentEnv === "uk" ? LOCAL_STORAGE_USER_KEY_UK : currentEnv === "eu" ? LOCAL_STORAGE_USER_KEY_EU : LOCAL_STORAGE_USER_KEY_US
  storage.setItem(key, token)
}

export const logoutUser = () => {
  const currentEnv = getCurrentEnvironment()
  const key = currentEnv === "uk" ? LOCAL_STORAGE_USER_KEY_UK : currentEnv === "eu" ? LOCAL_STORAGE_USER_KEY_EU : LOCAL_STORAGE_USER_KEY_US
  storage.removeItem(key)
}

export const createUser = async (data) => {
  return await userProvider.createUser(data)
}

export const loginUser = async (data) => {
  return await userProvider.loginUser(data.email, data.password)
}

export const sendForgetPasswordEmail = async (email) => {
  return await userProvider.sendForgetPasswordEmail(email)
}

export const resetPassword = async (token, password) => {
  return await userProvider.resetPassword(token, password)
}

export const getDetails = async () => {
  const token = getUserToken()
  return await accountProvider.getDetails(token)
}

export const getOrders = async () => {
  const token = getUserToken()
  return await accountProvider.getOrders(token)
}

export const updateDetails = async (data) => {
  const token = getUserToken()
  return await accountProvider.updateDetails(data, token)
}

export const updateAddresses = async (
  address,
  allAddress,
  addressId = null
) => {
  const token = getUserToken()

  const addressFields = Object.keys(address)
  addressFields.forEach((field) => {
    if (address[field] === "") {
      address[field] = null
    }
  })

  let addresses = []
  let customerId

  let allAddressList = []
  if(allAddress !== null && allAddress !== "undefined") {
    allAddressList = allAddress
  }

  allAddressList.forEach((currentAddress) => {
    if (currentAddress.id === addressId) {
      addresses.push(address)
    } else {
      let newAddress = { ...currentAddress }
      delete newAddress.customerShopifyId
      delete newAddress.name
      delete newAddress.id
      addresses.push(newAddress)
    }
    
  })
  if (!addressId) {
    addresses.push(address)
  }

  if(allAddressList.length > 0) {
    customerId = allAddressList[0].customerShopifyId
  }

  const data = {
    addressObject: addresses,
    customerShopifyId: customerId,
  }

  return await accountProvider.updateAddresses(data, token)
}

export const deleteAddress = async (allAddress, addressId) => {
  const token = getUserToken()
  const filteredAddress = allAddress.filter(
    (currentAddress) => currentAddress.id !== addressId
  )
  let customerId
  let addresses = []
  filteredAddress.forEach((currentAddress) => {
    customerId = currentAddress.customerShopifyId
    let newAddress = { ...currentAddress }
    delete newAddress.customerShopifyId
    delete newAddress.name
    delete newAddress.id
    addresses.push(newAddress)
  })

  const data = {
    addressObject: addresses,
    customerShopifyId: customerId,
  }
  return await accountProvider.updateAddresses(data, token)
}

export const createUserReferralCode = async (userToken=null) => {
  const token = userToken || getUserToken()
  return await accountProvider.createUserReferralCode(token)
}

export const getUserReferralCode = async () => {
  const token = getUserToken()
  return await accountProvider.getUserReferralCode(token)
}

export const getUserReferralCredit = async () => {
  const token = getUserToken()
  return await accountProvider.getReferralCredit(token);
}

export const getUserReferrals = async () => {
  const token = getUserToken()
  return await accountProvider.getUserReferrals(token)
}

export const createReferralDiscountCode = async () => {
  const token = getUserToken()
  return await accountProvider.createReferralDiscountCode(token);
}


export const updatePassword = async (data) => {
  const token = getUserToken()
  return await accountProvider.updatePassword(data, token)
}

export const resendConfirmationEmail = async (data) => {
  return await userProvider.resendConfirmationEmail(data);
}

export const confirmEmail = async (email, token) => {
  return await userProvider.confirmEmail({email, token})
}

export const sendReferralEmail = async (friendEmail) => {
  const token = getUserToken()
  return await accountProvider.sendReferralEmail({friendEmail: friendEmail}, token)
}

export const checkExistingAccount = async () => {
  const token = getUserToken()
  return await accountProvider.checkExistingAccount(token)
}